import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    FETCH_REPORTEE, FILTER,
    HOME_PAGE_CONTENT, LAST_FEWS_DAYS_INACTIVE_ACCOUNT
} from "./type";
import {fireEvent} from "../../component/MoEngage";


export const homePageContent = (data=[{}]) => async (dispatch) => {

    let urls = `${Config.HomePageContent}`
    Object.keys(data[0]).map((val, i)=>{
        if( i === 0){
            urls+="?"+val+"="+data[0][val]
        }else{
            urls+="&"+val+"="+data[0][val]
        }

    })
    const res = await callWebService(
        callTypes.get,
        '',
        urls,
    );

    fireEvent('debugging_event', {
        type: 'api_call',
        api_endpoint: urls,
        step: "api_request_start",
        page: window?.location?.pathname,
    });

    if (res) {
        const { data } = res;
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: urls,
            step: "api_request_success",
            page: window?.location?.pathname,
        });
        dispatch({
            type: HOME_PAGE_CONTENT,
            payload: data.response,
        });
        return true;
    } else {
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: urls,
            step: "api_request_fail",
            page: window?.location?.pathname,
        });
    }
};

export const fetchReportee = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.fetchReportee}`,
    );

    fireEvent('debugging_event', {
        type: 'api_call',
        api_endpoint: `${Config.fetchReportee}`,
        step: "api_request_start",
        page: window?.location?.pathname,
    });
    if (res) {
        const { data } = res;
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.fetchReportee}`,
            step: "api_request_success",
            page: window?.location?.pathname,
        });
        dispatch({
            type: FETCH_REPORTEE,
            payload: data.response,
        });
        return true;
    } else {
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.fetchReportee}`,
            step: "api_request_fail",
            page: window?.location?.pathname,
        });
    }
};

export const lastTenDaysInactiveAccount = (userId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.lastTenDaysInactiveAccount}?user_id=`+userId,

    );
    fireEvent('debugging_event', {
        type: 'api_call',
        api_endpoint: `${Config.lastTenDaysInactiveAccount}?user_id=`+userId,
        step: "api_request_start",
        page: window?.location?.pathname,
    });
    if (res) {
        const { data } = res;
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.lastTenDaysInactiveAccount}?user_id=`+userId,
            step: "api_request_success",
            page: window?.location?.pathname,
        });
        dispatch({
            type: LAST_FEWS_DAYS_INACTIVE_ACCOUNT,
            payload: data.response,
        });
        return true;
    } else {
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.lastTenDaysInactiveAccount}?user_id=`+userId,
            step: "api_request_fail",
            page: window?.location?.pathname,
        });
    }
};

export const homeFilter = (userId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.homeFilter}?user_id=`+userId,

    );
    fireEvent('debugging_event', {
        type: 'api_call',
        api_endpoint: `${Config.homeFilter}?user_id=`+userId,
        step: "api_request_start",
        page: window?.location?.pathname,
    });
    if (res) {
        const { data } = res;
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.homeFilter}?user_id=`+userId,
            step: "api_request_success",
            page: window?.location?.pathname,
        });
        dispatch({
            type: FILTER,
            payload: data.response,
        });
        return true;
    } else {
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.homeFilter}?user_id=`+userId,
            step: "api_request_fail",
            page: window?.location?.pathname,
        });
    }
};